export default __webpack_public_path__ + "static/custom-parallax-header-870168936e2dc1e7c542984c987d8618.mp4";